import React, { useState, useEffect } from "react";
import { DataNodeOfferingGroup, IOfferingGroupParamsTableRecord } from "./types";

interface IProps {
  treeData?: DataNodeOfferingGroup;
}

export const useOfferingGroupTreeTableData = (props: IProps) => {
  const { treeData } = props;

  // Для генерации строки таблицы при изменении offeringGroup
  const getTableRecord = (
    offeringGroupItem: DataNodeOfferingGroup
  ): IOfferingGroupParamsTableRecord => {
    return offeringGroupItem;
  };

  // Для генерации таблицы при изменении offeringGroup
  const getTableData = (): Array<IOfferingGroupParamsTableRecord> => {
    const data: Array<IOfferingGroupParamsTableRecord> = [];

    const addofferingGroupHierarchyData = (item: DataNodeOfferingGroup) => {
      data.push(getTableRecord(item));
      if (item?.children && item.children?.length > 0) {
        item.children.forEach((itemChild) => {
          addofferingGroupHierarchyData(itemChild as DataNodeOfferingGroup);
        });
      }
    };
    if (treeData) {
      addofferingGroupHierarchyData(treeData);
    }
    return data;
  };

  const [tableData, setTableData] = useState<Array<IOfferingGroupParamsTableRecord>>(
    getTableData()
  );

  // При изменении предложения перестраиваем таблицу иерархии заново
  useEffect(() => {
    if (treeData) {
      setTableData(getTableData());
    }
  }, [treeData]);

  return {
    tableData,
  };
};
